import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isNotEmpty } from "../../../helpers/StringHelpers"
import { BankAccountNumberValidator } from "../../../services/validation/bank-details-form/BankAccountNumberValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import { OptionBank } from "../../../services/ntuc/userService/staticData"

const BankAccountNumberField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        errorText,
        bankName,
    } = props

    const [errorMessage, setErrorMessage] = useState(errorText ?? ``)
    const [value, setValue] = useState(defaultValue ?? ``)

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
    }, [errorText])

    const validateField = (value: string) => {
        const validator = new BankAccountNumberValidator()
        const validationText = t(validator.validate(value, bankName as OptionBank) ?? ``, { bankName: bankName?.value, interpolation: { escapeValue: false } })
        setErrorMessage(validationText)
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setValue(event.target.value)
        handleChange(event.target.value)
    }
    const handleOnBlur = (event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
        validateField(event.target.value)
    }

    return (
        <TextField
            fullWidth
            error={isNotEmpty(errorMessage)}
            helperText={t(errorMessage, { bankName: bankName?.value, interpolation: { escapeValue: false } })}
            id="bank-account-number"
            label={t(`bank_account_number`)}
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            inputProps={{
                inputMode: `numeric`,
                pattern: `[0-9]*`,
            }}
        />
    )
}

export { BankAccountNumberField }